import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkOpenDirectMessagesToPlayer } from '../../redux/actions/directMessagesActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { PRIVATE_MESSAGES_PANEL_ACTIVE_USER_BACKGROUND_COLOR, PRIVATE_MESSAGES_PANEL_LIST_ITEM_HOVER_COLOR } from '../../styles/colors';
import { PanelItem } from '../panelItem';
const USERNAME_CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
`;
export const ConversationSelectPanelItem = ({ conversationIndex }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const playerIdName = useAppSelector((state) => state.directMessages.conversations[conversationIndex].playerIdName, shallowEqual);
    const onClickConversation = useCallback(() => {
        dispatch(thunkOpenDirectMessagesToPlayer(playerIdName, socketSend));
    }, [playerIdName, dispatch, socketSend]);
    return (_jsx(PanelItem, { onClick: onClickConversation, selectedColor: PRIVATE_MESSAGES_PANEL_ACTIVE_USER_BACKGROUND_COLOR, hoverColor: PRIVATE_MESSAGES_PANEL_LIST_ITEM_HOVER_COLOR, flexWrap: true, ariaLabel: playerIdName.name, dataTestId: 'conversation-user', children: _jsx("div", { css: USERNAME_CONTAINER_CSS, children: playerIdName.name }) }));
};
